import React, { type ReactNode } from 'react';
import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { isDevelopmentEnv } from './utils/node-env.tsx';

type Props = {
	hasServiceDeskAccess?: boolean | undefined;
	hasCoreAccess?: boolean | undefined;
	hasSoftwareAccess?: boolean | undefined;
	children: ReactNode;
};
const AppPermissionsCheckNew = ({
	hasServiceDeskAccess = undefined,
	hasCoreAccess = undefined,
	hasSoftwareAccess = undefined,
	children,
}: Props) => {
	const { appPermissions } = useTenantContext();
	if (hasServiceDeskAccess !== undefined && appPermissions.hasServiceDeskAccess) {
		return <>{children}</>;
	}
	if (hasCoreAccess !== undefined && appPermissions.hasCoreAccess === hasCoreAccess) {
		return <>{children}</>;
	}
	if (hasSoftwareAccess !== undefined && appPermissions.hasSoftwareAccess) {
		return <>{children}</>;
	}
	if (
		hasServiceDeskAccess === undefined &&
		hasCoreAccess === undefined &&
		hasSoftwareAccess === undefined
	) {
		if (isDevelopmentEnv()) {
			// eslint-disable-next-line no-console
			console.warn('AppPermissionsCheck should have defined at least one of access prop');
		}
		return <>{children}</>;
	}
	return null;
};

const AppPermissionsCheckOld = (props: Props) => {
	const { hasServiceDeskAccess, hasCoreAccess, hasSoftwareAccess, children } = props;
	const { appPermissions } = useTenantContext();
	if (hasServiceDeskAccess !== undefined && appPermissions.hasServiceDeskAccess) {
		return <>{children}</>;
	}
	if (hasCoreAccess !== undefined && appPermissions.hasCoreAccess === hasCoreAccess) {
		return <>{children}</>;
	}
	if (hasSoftwareAccess !== undefined && appPermissions.hasSoftwareAccess) {
		return <>{children}</>;
	}
	if (
		hasServiceDeskAccess === undefined &&
		hasCoreAccess === undefined &&
		hasSoftwareAccess === undefined
	) {
		if (isDevelopmentEnv()) {
			// eslint-disable-next-line no-console
			console.warn('AppPermissionsCheck should have defined at least one of access prop');
		}
		return <>{children}</>;
	}
	return null;
};

AppPermissionsCheckOld.defaultProps = {
	hasServiceDeskAccess: undefined,
	hasCoreAccess: undefined,
	hasSoftwareAccess: undefined,
};

/**
 * Manages the visibility of child components based on user permissions within a multi-tenant environment.
 * It leverages the application's permission settings to determine access rights, ensuring components are only accessible to users with the appropriate permissions.
 * In development environments, it issues a warning when no access-related properties are provided, aiding in debug and development processes.
 */
const AppPermissionsCheck = componentWithFG(
	'jira_removing_defaultprops',
	AppPermissionsCheckNew,
	AppPermissionsCheckOld,
);

export default AppPermissionsCheck;
